var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V1.12118C0.00178638 1.25321 0.0530559 1.37914 0.142642 1.47155L7.06557 8.83933C7.15515 8.93174 7.20642 9.05768 7.20821 9.1897V16.087C7.20803 16.1808 7.2329 16.2728 7.27998 16.3524C7.32706 16.4321 7.39445 16.4962 7.47447 16.5375L11.2307 17.9489C11.3033 17.9864 11.3837 18.0037 11.4644 17.9993C11.5451 17.995 11.6234 17.969 11.6919 17.9239C11.7605 17.8788 11.8169 17.8161 11.856 17.7417C11.8951 17.6672 11.9156 17.5835 11.9154 17.4985V9.0996C11.9286 8.96431 11.9897 8.8392 12.0866 8.74923L18.8574 1.49157C18.9469 1.39916 18.9982 1.27323 19 1.1412V0H0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.7e8ef08c.svg";
export { ForwardRef as ReactComponent };